var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination"},_vm._l((_vm.total),function(n){return _c('span',{key:n,staticClass:"pagination__child",class:(_vm.current >= n)? 'pagination__child--active':'pagination__child--inactive'})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }